import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Loader from '../../Components/utils/Loader';
import SEO from '../../Components/utils/SEO';

function Terms() {

    const [terms, setTerms] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/terms`)
            .then(res => {
                if (res.data.success) {
                    setTerms(res.data?.terms || "");
                }
            })
            .finally(() => setIsLoading(false));
    }, []);

    return (
        <div className='termsDiv'>
            <SEO
                title="Terms and conditions"
                description="Read Chocowi terms and conditions for buyers, sellers, and suppliers."
                canonicalPath="/terms"
            />
            <div className="termsContent">
                <h1 className='primaryHeading'>Terms and Conditions</h1>
                {isLoading? <Loader type="simpleMini" /> : <div className="termsTextDiv">
                    <div dangerouslySetInnerHTML={{ __html: terms }} />
                </div>}
            </div>
        </div>
    );
}

export default Terms;
